import { fetchSameOrigin } from '../Utils';
import {React} from 'react';

function rejectCareRecipient(careRecipientId, caregiverRoleId, message) {
  return fetchSameOrigin(
    `/members/${careRecipientId}/caregivers/${caregiverRoleId}/reject`, 
    'PUT',
    { body: JSON.stringify({
    caregiver_id: caregiverRoleId,
    member_id: careRecipientId,
    message: message})}
  )
  .then(r => r.json())
  .then(({ message, error })=> new Promise((resolve) => {
    resolve({
      message,
      error: !!error && !!error.length && (<ul><li>{error}</li></ul>)
    });
  })
  .finally(() =>{
    window.location.reload()
  }));
}

export default rejectCareRecipient;
